import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="container-fluid tw-bg-slate-950 tw-text-slate-300 tw-pt-5 tw-pb-4">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-4">
            <div className="d-flex align-items-center gap-2 tw-mb-3">
              <ShieldCheck size={22} className="tw-text-cyan-400" />
              <h5 className="tw-text-white tw-font-bold tw-mb-0">CyberShield</h5>
            </div>
            <p className="tw-text-slate-400 tw-leading-7">
              Practical cybersecurity and logistics software solutions focused on
              secure operations, protected data, and reliable business workflows.
            </p>
          </div>

          <div className="col-sm-6 col-lg-2">
            <h6 className="tw-text-white tw-font-semibold tw-mb-3">Quick Links</h6>
            <ul className="list-unstyled tw-space-y-2">
              <li><Link className="tw-text-slate-400 hover:tw-text-cyan-400 tw-no-underline" to="/">Home</Link></li>
              <li><Link className="tw-text-slate-400 hover:tw-text-cyan-400 tw-no-underline" to="/products">Products</Link></li>
              <li><Link className="tw-text-slate-400 hover:tw-text-cyan-400 tw-no-underline" to="/services">Services</Link></li>
              <li><Link className="tw-text-slate-400 hover:tw-text-cyan-400 tw-no-underline" to="/about">About</Link></li>
              <li><Link className="tw-text-slate-400 hover:tw-text-cyan-400 tw-no-underline" to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="col-sm-6 col-lg-3">
            <h6 className="tw-text-white tw-font-semibold tw-mb-3">Services</h6>
            <ul className="list-unstyled tw-space-y-2 tw-text-slate-400">
              <li>Application Security</li>
              <li>Data Protection</li>
              <li>Threat Monitoring</li>
              <li>System Hardening</li>
            </ul>
          </div>

          <div className="col-lg-3">
            <h6 className="tw-text-white tw-font-semibold tw-mb-3">Contact</h6>
            <div className="tw-space-y-3 tw-text-slate-400">
              <p className="tw-mb-2 d-flex align-items-center gap-2">
                <Mail size={16} className="tw-text-cyan-400" />
                info@cybershield.com
              </p>
              <p className="tw-mb-2 d-flex align-items-center gap-2">
                <Phone size={16} className="tw-text-cyan-400" />
                +91 98765 43210
              </p>
              <p className="tw-mb-0 d-flex align-items-center gap-2">
                <MapPin size={16} className="tw-text-cyan-400" />
                Chennai, India
              </p>
            </div>
          </div>
        </div>

        <hr className="tw-border-slate-800 tw-my-4" />

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
          <p className="tw-mb-0 tw-text-slate-500">
            © 2026 CyberShield. All rights reserved.
          </p>
          <p className="tw-mb-0 tw-text-slate-500">
            Secure Systems • Protected Data • Reliable Operations
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;